"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryErrorTypeSchema = exports.BoundaryErrorType = exports.IBoundaryValueWithSourceSchema = exports.IBoundaryErrorSchema = exports.IBoundaryErrorCircuitObjectSchema = exports.IBoundaryErrorCircuitObjectNetConnectionSchema = exports.IBoundaryErrorCircuitObjectComponentSchema = exports.IBoundaryErrorCircuitObjectModuleSchema = exports.IBoundaryErrorCircuitObjectNetSchema = exports.IBoundaryErrorCircuitObjectBaseSchema = void 0;
const zod_1 = require("zod");
const IBoundaryInstance_1 = require("./IBoundaryInstance");
const BoundaryLevel_1 = require("../BoundaryLevel");
const ISerializedCircuitState_1 = require("../CircuitStates/ISerializedCircuitState");
exports.IBoundaryErrorCircuitObjectBaseSchema = zod_1.z.object({
    type: zod_1.z.string(),
});
exports.IBoundaryErrorCircuitObjectNetSchema = exports.IBoundaryErrorCircuitObjectBaseSchema.extend({
    type: zod_1.z.literal('net'),
    net: zod_1.z.string(),
});
exports.IBoundaryErrorCircuitObjectModuleSchema = exports.IBoundaryErrorCircuitObjectBaseSchema.extend({
    type: zod_1.z.literal('module'),
    module: zod_1.z.string(),
});
exports.IBoundaryErrorCircuitObjectComponentSchema = exports.IBoundaryErrorCircuitObjectBaseSchema.extend({
    type: zod_1.z.literal('component'),
    component: zod_1.z.string(),
});
const signalStringSchema = zod_1.z
    .union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())])
    .transform((val) => (Array.isArray(val) ? (val[0] ?? '') : val));
exports.IBoundaryErrorCircuitObjectNetConnectionSchema = exports.IBoundaryErrorCircuitObjectBaseSchema.extend({
    type: zod_1.z.literal('netconn'),
    module: zod_1.z.string(),
    signal: signalStringSchema,
    net: zod_1.z.string(),
});
exports.IBoundaryErrorCircuitObjectSchema = zod_1.z.discriminatedUnion('type', [
    exports.IBoundaryErrorCircuitObjectNetSchema,
    exports.IBoundaryErrorCircuitObjectModuleSchema,
    exports.IBoundaryErrorCircuitObjectComponentSchema,
    exports.IBoundaryErrorCircuitObjectNetConnectionSchema,
]);
exports.IBoundaryErrorSchema = zod_1.z.object({
    id: zod_1.z.string(),
    errorId: zod_1.z.string(),
    level: BoundaryLevel_1.BoundaryLevelSchema,
    message: zod_1.z.string(),
    boundary: IBoundaryInstance_1.IBoundaryInstanceSchema,
    circuitState: zod_1.z.lazy(() => ISerializedCircuitState_1.SerializedCircuitStateOrPointerSchema).optional(),
    circuitObjects: zod_1.z
        .lazy(() => exports.IBoundaryErrorCircuitObjectSchema)
        .array()
        .optional(),
    targetNet: zod_1.z.string().optional(),
    relativeNet: zod_1.z.string().optional(),
    actualVal: zod_1.z
        .union([
        zod_1.z.number(),
        zod_1.z.object({
            value: zod_1.z.number(),
            source: exports.IBoundaryErrorCircuitObjectSchema,
        }),
    ])
        .optional(),
});
exports.IBoundaryValueWithSourceSchema = zod_1.z.object({
    value: zod_1.z.number(),
    source: exports.IBoundaryErrorCircuitObjectSchema,
});
var BoundaryErrorType;
(function (BoundaryErrorType) {
    BoundaryErrorType["MaxValExceeded"] = "BoundaryMaxValExceeded";
    BoundaryErrorType["MinValNotReached"] = "BoundaryMinValExceeded";
    BoundaryErrorType["AbsoluteValNotEqual"] = "BoundaryAbsoluteValNotEqual";
    BoundaryErrorType["SignalReferenceError"] = "BoundarySignalReferenceError";
})(BoundaryErrorType || (exports.BoundaryErrorType = BoundaryErrorType = {}));
exports.BoundaryErrorTypeSchema = zod_1.z.nativeEnum(BoundaryErrorType);
//# sourceMappingURL=BoundaryErrorsDefinition.js.map